import * as Library from '../../../core/library/index';
import { Tier } from './tier';

export class Apr {
  public tiers: Tier[];

  public hasTiers() {
    return Library.isArrayWithLength(this.tiers);
  }

  public getLowestAprForLongestTerm() {
    if (this.hasTiers()) {
      const list = this.tiers.map(t => t.getLowestAprForLongestTerm());
      const rate = list[0].rate;
      list.filter(i => i.rate === rate).sort(this._compareTerm);
      return list[0];
    }
  }

  //
  // Sort By Rate (ascending)
  //
  private _compareRate(a, b) {
    const x = parseFloat(a.rate);
    const y = parseFloat(b.rate);

    if (x < y) {
      return -1;
    }

    if (x > y) {
      return 1;
    }

    return 0;
  }

  //
  // Sort By Term (descending)
  //
  private _compareTerm(a, b) {
    const x = parseFloat(a.duration);
    const y = parseFloat(b.duration);

    if (x > y) {
      return -1;
    }

    if (x < y) {
      return 1;
    }

    return 0;
  }

  //
  // Constructor
  //
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    this.tiers = [];
    if (Library.hasOwnProperty(options, 'tiers')) {
      if (Library.isArrayWithLength(options.tiers)) {
        this.tiers = options.tiers.map(t => new Tier(t));
      }
    }
  }
}
